import React, { useState } from 'react';
import axios from 'axios';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import { FaceAgent } from 'mdi-material-ui';
import { components } from '@episource/epi-storybook';
import Loading from '../Loading';

import epiPortalWhiteLogo from '../../assets/images/epi-portal-white.svg';

import FeedbackBox from '../FeedbackBox';
import HelpForm from './HelpForm';

const { Header: EpiHeader } = components;

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    width: 740,
  },
  paper: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
  },
  avatar: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  logo: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(4),
  },
}));

export default function Help() {
  const classes = useStyles();

  const [formState, setFormState] = useState('form');

  async function handleSubmit(values) {
    try {
      // eslint-disable-next-line no-param-reassign
      if (values.application !== 'EpiAnalyst') values.businessLine = 'n/a';
      const ticketValues = new FormData();
      for (const [key, value] of Object.entries(values)) {
        ticketValues.append(key, value);
      }

      await axios.post(
        `${process.env.REACT_APP_EPI_CLIENT_API_URL}/api/v1/emails/submit-ticket`,
        ticketValues
      );

      setFormState('success');
    } catch (err) {
      // TODO: comment out!
      // if (process.env.NODE_ENV === 'development') console.error(err);
      setFormState('error');
    }
  }

  function handleBack() {
    setFormState('form');
  }

  return (
    <>
      <Loading />
      <EpiHeader
        navBar={[]}
        imageLogo={<img className={classes.logo} src={epiPortalWhiteLogo} alt="Epi Portal" />}
      />
      <Container className={classes.wrapper} fixed>
        <Paper className={classes.paper}>
          <Grid container spacing={3} justify="center">
            <Grid item xs={12} sm={11}>
              <div className={classes.sectionTitle}>
                <Avatar className={classes.avatar}>
                  <FaceAgent />
                </Avatar>
                <Typography variant="h5" component="h3">
                  Help and Support
                </Typography>
              </div>
              {formState === 'form' && <HelpForm handleSubmit={handleSubmit} />}
              {formState === 'success' && (
                <FeedbackBox
                  variant="success"
                  title="Ticket Submitted!"
                  message="We're working on it."
                  buttonText="Back"
                  action={handleBack}
                />
              )}
              {formState === 'error' && (
                <FeedbackBox
                  variant="error"
                  title="Submission Error"
                  message="Oops! Something went wrong. Please contact one of our administrators."
                  buttonText="Back"
                  action={handleBack}
                />
              )}
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
}
